import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Paper, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { base64Image } from '../assets/base64Image';
import logo_con_scritta from "../assets/logo_con_scritta.svg";
import { setCookie } from '../services/cookies';

interface LoginPageProps {
    onLogin: () => void;
    setUserName: (UserName: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin, setUserName }) => {

    const [error, setError] = useState<string | null>(null);
    const [showPassword, setShowPassword] = useState(false);

    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const navigate = useNavigate()

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const check = Date.now();
            const response = await fetch('/api/v0/loginweb', {
                method: 'POST',
                body: JSON.stringify({ username, password, check }),
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.ok) {
                const data = await response.json();
                //setToken(data.token)
                setUserName(username)
                navigate('/esercizi')
                onLogin()
            } else {
                const errorData = await response.json();
                setError(errorData.error);
            }
        } catch (error) {
            setError('Si è verificato un errore, per favore riprova più tardi.');
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };




    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor="#f5f5f5"
            sx={{
                backgroundImage: `url(${base64Image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderRadius: 17,
            }}
        >
            <div className='white-panel p-5'>
                <img src={logo_con_scritta} alt="logo" width={400} />
                <Typography variant="h2" my={5} >Benvenuto!</Typography>
                <div className='mb-3'>
                    <TextField
                        fullWidth
                        label="Username"
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className='mb-3'>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Password"
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={togglePasswordVisibility}>
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                {error && <Typography color="error" variant="body2">{error}</Typography>}
                <div className='mt-3 text-center'>

                    <button className='btn text-center' style={{ backgroundColor: "#0D5C37", color: "white", alignItems: "center", }} onClick={handleLogin}>
                        Accedi
                    </button>
                </div>

            </div>
        </Box>
    );
};

export default LoginPage;
